import ContentWrapper from './contentWrapper';

export default ContentWrapper;